var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735902821920,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5828,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 226m19.96 0l184.08 0q19.96 0 19.96 19.96l0 660.08q0 19.96-19.96 19.96l-184.08 0q-19.96 0-19.96-19.96l0-660.08q0-19.96 19.96-19.96Z",
    fill: "#20C997",
    "p-id": 5829
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 354.6a66.84 66.76 90 1 0 133.52 0 66.84 66.76 90 1 0-133.52 0Z",
    fill: "#0CA678",
    "p-id": 5830
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 790.88m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#0CA678",
    "p-id": 5831
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 844.78m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#0CA678",
    "p-id": 5832
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M402 118m19.96 0l184.08 0q19.96 0 19.96 19.96l0 660.08q0 19.96-19.96 19.96l-184.08 0q-19.96 0-19.96-19.96l0-660.08q0-19.96 19.96-19.96Z",
    fill: "#FF6B6B",
    "p-id": 5833
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M447.24 246.6a66.84 66.76 90 1 0 133.52 0 66.84 66.76 90 1 0-133.52 0Z",
    fill: "#FA5252",
    "p-id": 5834
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M447.24 682.88m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#FA5252",
    "p-id": 5835
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M447.24 736.78m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#FA5252",
    "p-id": 5836
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M688 184m19.96 0l184.08 0q19.96 0 19.96 19.96l0 660.08q0 19.96-19.96 19.96l-184.08 0q-19.96 0-19.96-19.96l0-660.08q0-19.96 19.96-19.96Z",
    fill: "#329AF0",
    "p-id": 5837
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M733.24 312.6a66.84 66.76 90 1 0 133.52 0 66.84 66.76 90 1 0-133.52 0Z",
    fill: "#1C7CD6",
    "p-id": 5838
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M733.24 748.88m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#1C7CD6",
    "p-id": 5839
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M733.24 802.78m13.64 0l106.26 0q13.64 0 13.64 13.64l0 0.04q0 13.64-13.64 13.64l-106.26 0q-13.64 0-13.64-13.64l0-0.04q0-13.64 13.64-13.64Z",
    fill: "#1C7CD6",
    "p-id": 5840
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceType);
export default __webpack_public_path__ + "static/media/balanceType.224ab3bd7ff46e241a017842487108f9.svg";
export { ForwardRef as ReactComponent };